/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Toast_Created_VerifyInputs */

const en_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created! You may need to verify your email.`)
};

const es_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Cuenta creada! Es posible que debas verificar tu email.`)
};

const de_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellt! Möglicherweise müssen Sie Ihre E-Mail-Adresse bestätigen.`)
};

const zh_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户已创建！你可能需要验证电子邮件。`)
};

const ar_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إنشاء الحساب! قد تحتاج إلى التحقق من بريدك الإلكتروني.`)
};

const fr_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte créé ! Vous devrez peut-être vérifier votre adresse e-mail.`)
};

const vi_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo tài khoản! Bạn có thể cần xác minh email.`)
};

const sw_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti imeundwa! Huenda ukahitaji kuthibitisha barua pepe yako.`)
};

const th_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างบัญชีแล้ว! คุณอาจต้องยืนยันอีเมลของคุณ`)
};

const bs_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Račun je kreiran! Možda trebate potvrditi email.`)
};

const ja_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成しました！メールアドレスの確認が必要な場合があります。`)
};

const ko_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 생성되었습니다! 이메일 인증이 필요할 수 있습니다.`)
};

const pt_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta criada! Você pode precisar verificar seu e-mail.`)
};

const it_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account creato! Potresti dover verificare la tua email.`)
};

const sv_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto skapat! Du kan behöva verifiera din e-post.`)
};

const nl_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account aangemaakt! Mogelijk moet je je e-mailadres bevestigen.`)
};

const da_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoen er oprettet! Du skal muligvis bekræfte din e-mail.`)
};

const nb_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto opprettet! Du må kanskje bekrefte e-posten din.`)
};

const fi_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tili luotu! Voit joutua vahvistamaan sähköpostisi.`)
};

const pl_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utworzono konto! Może być konieczne potwierdzenie adresu e-mail.`)
};

const ru_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунт создан! Возможно, потребуется подтвердить адрес электронной почты.`)
};

const tr_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap oluşturuldu! E-postanızı doğrulamanız gerekebilir.`)
};

const hi_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता बन गया! आपको अपना ईमेल सत्यापित करना पड़ सकता है।`)
};

const id_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun berhasil dibuat! Anda mungkin perlu memverifikasi email Anda.`)
};

const ms_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun dicipta! Anda mungkin perlu mengesahkan e-mel anda.`)
};

const cs_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet byl vytvořen! Možná budete muset ověřit svůj e-mail.`)
};

const el_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο λογαριασμός δημιουργήθηκε! Ίσως χρειαστεί να επαληθεύσετε το email σας.`)
};

const he_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החשבון נוצר! ייתכן שתצטרכו לאמת את כתובת הדוא״ל שלכם.`)
};

const af_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekening geskep! Jy moet dalk jou e-posadres verifieer.`)
};

const hu_auth_inline_toast_created_verify = /** @type {(inputs: Auth_Inline_Toast_Created_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fiók létrejött! Lehet, hogy meg kell erősítenie az e-mail-címét.`)
};

/**
* | output |
* | --- |
* | "Account created! You may need to verify your email." |
*
* @param {Auth_Inline_Toast_Created_VerifyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_toast_created_verify = /** @type {((inputs?: Auth_Inline_Toast_Created_VerifyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Toast_Created_VerifyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_toast_created_verify(inputs)
	if (locale === "de") return de_auth_inline_toast_created_verify(inputs)
	if (locale === "zh") return zh_auth_inline_toast_created_verify(inputs)
	if (locale === "ar") return ar_auth_inline_toast_created_verify(inputs)
	if (locale === "fr") return fr_auth_inline_toast_created_verify(inputs)
	if (locale === "vi") return vi_auth_inline_toast_created_verify(inputs)
	if (locale === "sw") return sw_auth_inline_toast_created_verify(inputs)
	if (locale === "th") return th_auth_inline_toast_created_verify(inputs)
	if (locale === "bs") return bs_auth_inline_toast_created_verify(inputs)
	if (locale === "ja") return ja_auth_inline_toast_created_verify(inputs)
	if (locale === "ko") return ko_auth_inline_toast_created_verify(inputs)
	if (locale === "pt") return pt_auth_inline_toast_created_verify(inputs)
	if (locale === "it") return it_auth_inline_toast_created_verify(inputs)
	if (locale === "sv") return sv_auth_inline_toast_created_verify(inputs)
	if (locale === "nl") return nl_auth_inline_toast_created_verify(inputs)
	if (locale === "da") return da_auth_inline_toast_created_verify(inputs)
	if (locale === "nb") return nb_auth_inline_toast_created_verify(inputs)
	if (locale === "fi") return fi_auth_inline_toast_created_verify(inputs)
	if (locale === "pl") return pl_auth_inline_toast_created_verify(inputs)
	if (locale === "ru") return ru_auth_inline_toast_created_verify(inputs)
	if (locale === "tr") return tr_auth_inline_toast_created_verify(inputs)
	if (locale === "hi") return hi_auth_inline_toast_created_verify(inputs)
	if (locale === "id") return id_auth_inline_toast_created_verify(inputs)
	if (locale === "ms") return ms_auth_inline_toast_created_verify(inputs)
	if (locale === "cs") return cs_auth_inline_toast_created_verify(inputs)
	if (locale === "el") return el_auth_inline_toast_created_verify(inputs)
	if (locale === "he") return he_auth_inline_toast_created_verify(inputs)
	if (locale === "af") return af_auth_inline_toast_created_verify(inputs)
	if (locale === "hu") return hu_auth_inline_toast_created_verify(inputs)
	return en_auth_inline_toast_created_verify(inputs)
});